/* src/app/main/sales/list/sales-list.component.scss */
/*# sourceMappingURL=sales-list.component-TAMCJOGA.css.map */
